import React from 'react';

const Spinner = ({ padding, isSmall }) => {
  !isSmall && typeof window !== 'undefined' && window.scrollTo(0, 0);
  return (
    <div
      className={`${isSmall ? 'spinner-small' : 'spinnerContainer'} Black ${
        padding && 'spinner-padding'
      }`}
    >
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
